import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';  // Import signOut for logging out
import { auth } from '../config/firebaseConfig';  // Import your Firebase configuration
import LoadingSpinner from '../components/LoadingSpinner';  // Assuming you have a loading spinner component

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // The logout function
  const logout = async () => {
    try {
      await signOut(auth);  // Firebase signOut method
      setUser(null);  // Set user state to null after logging out
    } catch (error) {
      console.error("Error logging out: ", error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {loading ? <LoadingSpinner /> : children}
    </AuthContext.Provider>
  );
};
